import { ObjectHandler } from './ObjectHandler';
import jQuery from 'jquery';
import gsap from 'gsap';
export class MenuHandler extends ObjectHandler {
    constructor(id) {
        super(id);
    }

    init() {
		this.events();
    }

    destroy() {

    }

	events() {
		jQuery('.main-navigation__lines').on('click', function() {
			jQuery(this).toggleClass('main-navigation__lines--open')
			if (jQuery(this).hasClass('main-navigation__lines--open'))
			{
				gsap.to('#site-navigation', {autoAlpha: 1, duration: 0.3})
			}
			else
				gsap.to('#site-navigation', {autoAlpha: 0, duration: 0.3})

		})
	}
}